var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mheader"},[_c('img',{attrs:{"src":require("./../../assets/m-home/daohangtiao.png"),"alt":""},on:{"click":_vm.menuShow}}),_c('img',{attrs:{"src":require("./../../assets/m-home/logo.png"),"alt":""},on:{"click":_vm.toHome}})])
}
var staticRenderFns = []

export { render, staticRenderFns }